import { BATTLESHIP, CALYPSO } from 'HubStyleTokens/colors';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIFlex from 'UIComponents/layout/UIFlex';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { useState } from 'react';
import styled from 'styled-components';
import { ADD_ON_CARD } from '../../constants/tracking/Locations';
import { useAppSelector } from '../../reducers';
import { hasPricingAndPurchasingFailedSelector, hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import { billingNameKeySelector, productForSkuIdSelector } from '../../selectors/ProductsSelectors';
import { useQueryParamTerm } from '../../utils/urls/appQueryParamUtils';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import { AddOnCardCTA } from './AddOnCardCTA';
import { AddOnCardCTAFallback, AddOnCardPricingFallback } from './AddOnCardFallbacks';
import { AddOnCardPricing } from './AddOnCardPricing';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledAddOnCard = styled.div.withConfig({
  displayName: "AddOnCard__StyledAddOnCard",
  componentId: "jrsmfz-0"
})(["padding:24px;border:", ";margin-bottom:16px;"], props => props.highlighted ? `2px solid ${CALYPSO}` : `1px solid ${BATTLESHIP}`);
export const AddOnCard = ({
  highlighted = false,
  screen,
  skuId
}) => {
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const hasPricingAndPurchasingSucceeded = useAppSelector(hasPricingAndPurchasingSucceededSelector);
  const hasPricingAndPurchasingFailed = useAppSelector(hasPricingAndPurchasingFailedSelector);
  const productConfigurations = [createProductConfig({
    skuId,
    quantity: selectedQuantity
  })];
  const billingNameKey = useAppSelector(state => billingNameKeySelector(state, {
    skuId
  }));
  const product = useAppSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  return /*#__PURE__*/_jsx(StyledAddOnCard, {
    highlighted: highlighted,
    "data-test-id": `${ADD_ON_CARD}-${product.apiName}`,
    "data-selenium-id": `${ADD_ON_CARD}-${product.apiName}`,
    children: /*#__PURE__*/_jsxs(UIFlex, {
      direction: "column",
      gap: 15,
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        direction: "row",
        justify: "between",
        style: {
          width: '100%'
        },
        children: [/*#__PURE__*/_jsxs(UIFlex, {
          direction: "column",
          style: {
            fontWeight: '500'
          },
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: `pricing-pages.products.${billingNameKey}.title`
          }), /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
            isLoading: !hasPricingAndPurchasingSucceeded,
            isError: hasPricingAndPurchasingFailed,
            heights: [18],
            widths: [63],
            className: "flex-column",
            Content: AddOnCardPricing,
            contentProps: {
              productConfigurations,
              skuId,
              term: queryParamTerm
            },
            ErrorContent: AddOnCardPricingFallback
          })]
        }), /*#__PURE__*/_jsx(UIFlex, {
          direction: "row",
          justify: "end",
          gap: 10,
          children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
            isLoading: !hasPricingAndPurchasingSucceeded,
            isError: hasPricingAndPurchasingFailed,
            heights: [40],
            widths: [157],
            className: "flex-column",
            Content: AddOnCardCTA,
            contentProps: {
              skuId,
              screen,
              term: queryParamTerm,
              selectedQuantity,
              productConfigurations,
              onQuantityChange: setSelectedQuantity
            },
            ErrorContent: AddOnCardCTAFallback,
            errorContentProps: {
              skuId
            }
          })
        })]
      }), /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx("p", {
          className: "m-bottom-2",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `pricing-pages.products.${billingNameKey}.paragraph`
          })
        })
      })]
    })
  });
};